import {
  ArrowBackIosNew,
  ArrowForwardIos,
  Close,
  Place as PlaceIcon,
} from "@mui/icons-material";
import {
  Box,
  Dialog,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { iresoftColors } from "../../../theme/ireColors";
import { Place } from "../../../types/place";

interface DetailCardProps {
  place: Place;
  onClose: () => void;
  onNext: () => void;
  onPrev: () => void;
  hideControls?: boolean;
}

const DetailCard: React.FC<DetailCardProps> = ({
  place,
  onClose,
  onNext,
  onPrev,
  hideControls = false,
}) => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  return (
    <Dialog
      open
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      disableScrollLock
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 3,
          p: 0,
          m: 0,
          display: "flex",
          flexDirection: "column",
          height: "600px",
          maxHeight: "90vh",
          overflow: "hidden",
          cursor: "default",
        },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={2}
        py={1}
        borderBottom="1px solid #eee"
      >
        <Box sx={{ opacity: 0.8 }}>
          {hideControls && (
            <>
              <IconButton onClick={onPrev} sx={{ mr: 1 }}>
                <ArrowBackIosNew />
              </IconButton>
              <IconButton onClick={onNext}>
                <ArrowForwardIos />
              </IconButton>
            </>
          )}
        </Box>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </Box>

      <Box
        display="flex"
        flexDirection={isSmallScreen ? "column" : "row"}
        flex={1}
        overflow="hidden"
      >
        <Box
          flex={1}
          p={isSmallScreen ? 2 : 4}
          display="flex"
          flexDirection="column"
          gap={2}
          overflow="hidden"
        >
          <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="h3" fontWeight={700}>
              {place.title}
            </Typography>
            <Box display="flex" alignItems="center" gap={0.5}>
              <PlaceIcon
                sx={{ color: iresoftColors.iresoftRed }}
                fontSize="small"
              />
              <Typography
                variant="subtitle1"
                fontWeight={500}
                sx={{ color: iresoftColors.black80 }}
              >
                {place.placeName}
              </Typography>
            </Box>
          </Box>
          <Box
            flex={1}
            overflow="auto"
            sx={{ minHeight: isSmallScreen ? 100 : "auto" }}
          >
            {place.title && (
              <Typography
                variant="body1"
                sx={{
                  pr: 2,
                  whiteSpace: "pre-line",
                  overflowWrap: "break-word",
                }}
              >
                {place.description}
              </Typography>
            )}
          </Box>
        </Box>

        {place.image && (
          <Box
            flexShrink={0}
            width={isSmallScreen ? "100%" : 550}
            height={isSmallScreen ? 200 : "100%"}
            display="flex"
            alignItems="center"
            justifyContent="center"
            p={isSmallScreen ? 2 : 3}
          >
            <Box
              component="img"
              src={`data:image/jpeg;base64,${place.image}`}
              alt={place.title || "Avatar"}
              sx={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                borderRadius: 4,
              }}
            />
          </Box>
        )}
      </Box>
    </Dialog>
  );
};

export default DetailCard;
